/**
 * Expression of Interest Form - Multi-Select Dropdown (Bakers Delight)
 * Custom implementation based on store-search component
 */

(function () {
    'use strict';

    let initialized = false;

    function forceInitMultiSelectDropdowns() {
        if (initialized) return;

        const section = document.querySelector('.expression-of-interest');
        if (!section) return;

        const checkboxGroups = section.querySelectorAll('.custom-multiselect');
        if (checkboxGroups.length === 0) return;

        let successCount = 0;
        checkboxGroups.forEach((group) => {
            const success = setupMultiSelectDropdown(group);
            if (success) successCount++;
        });

        if (successCount > 0) {
            initialized = true;
        }
    }

    function setupMultiSelectDropdown(container) {
        if (container.classList.contains('dropdown-initialized')) return true;

        const checkboxList = container.querySelector('.globo-form-input ul');
        if (!checkboxList) return false;

        let checkboxElements = Array.from(checkboxList.querySelectorAll('li.globo-list-control'));
        if (checkboxElements.length === 0) {
            checkboxElements = Array.from(checkboxList.querySelectorAll('.checkbox-wrapper'));
        }
        if (checkboxElements.length === 0) return false;

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'eoi-multiselect-wrapper';

        // Create input wrapper
        const inputWrapper = document.createElement('div');
        inputWrapper.className = 'eoi-input-wrapper';

        // Create input field
        const input = document.createElement('input');
        input.type = 'text';
        input.className = 'eoi-input';
        input.placeholder = 'Select your position';
        input.setAttribute('aria-label', 'Select your position');
        input.setAttribute('autocomplete', 'off');
        input.readOnly = true;
        inputWrapper.appendChild(input);

        // Create dropdown icon
        const iconContainer = document.createElement('div');
        iconContainer.className = 'eoi-dropdown-icon';
        iconContainer.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6L8 10L12 6" stroke="#862633" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

        inputWrapper.appendChild(iconContainer);
        wrapper.appendChild(inputWrapper);

        // Create results list
        const results = document.createElement('div');
        results.className = 'eoi-results';
        results.setAttribute('role', 'listbox');
        results.setAttribute('aria-multiselectable', 'true');

        // Create options
        checkboxElements.forEach((element, index) => {
            const checkboxWrapper = element.querySelector('.checkbox-wrapper') || element;
            const originalCheckbox = checkboxWrapper.querySelector('input[type="checkbox"]');
            const originalLabel = checkboxWrapper.querySelector('label');

            if (!originalCheckbox || !originalLabel) return;

            const option = document.createElement('div');
            option.className = 'eoi-option';
            option.setAttribute('role', 'option');
            option.dataset.index = index;
            option.dataset.value = originalCheckbox.value;

            const label = document.createElement('label');
            label.className = 'eoi-option-label';

            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.className = 'eoi-checkbox';
            checkbox.id = `eoi-checkbox-${index}`;
            label.appendChild(checkbox);

            const text = document.createElement('span');
            text.className = 'eoi-option-text';
            text.textContent = originalLabel.textContent.trim();
            label.appendChild(text);

            option.appendChild(label);
            results.appendChild(option);

            // Click handler
            label.addEventListener('click', (e) => {
                e.preventDefault();
                originalCheckbox.checked = !originalCheckbox.checked;
                originalCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
                updateUI(container, results, input);
            });

            // Sync initial state
            if (originalCheckbox.checked) {
                checkbox.checked = true;
                label.classList.add('eoi-option-label--selected');
                option.setAttribute('aria-selected', 'true');
            }

            // Listen to original checkbox changes
            originalCheckbox.addEventListener('change', () => {
                checkbox.checked = originalCheckbox.checked;
                if (originalCheckbox.checked) {
                    label.classList.add('eoi-option-label--selected');
                    option.setAttribute('aria-selected', 'true');
                } else {
                    label.classList.remove('eoi-option-label--selected');
                    option.setAttribute('aria-selected', 'false');
                }
                updateUI(container, results, input);
            });
        });

        wrapper.appendChild(results);

        // Create chips container
        const chips = document.createElement('div');
        chips.className = 'eoi-chips hidden';
        wrapper.appendChild(chips);

        // Insert wrapper AFTER the label
        const label = container.querySelector('.globo-label');
        if (label && label.nextSibling) {
            container.insertBefore(wrapper, label.nextSibling);
        } else {
            container.appendChild(wrapper);
        }

        // Toggle dropdown
        const toggleDropdown = () => {
            const isOpen = results.classList.contains('open');
            if (isOpen) {
                results.classList.remove('open');
                iconContainer.classList.remove('open');
            } else {
                results.classList.add('open');
                iconContainer.classList.add('open');
            }
        };

        // Click anywhere on input wrapper to toggle dropdown
        inputWrapper.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
        });

        // Don't allow focus on input
        input.addEventListener('focus', (e) => {
            e.preventDefault();
            input.blur();
        });

        // Close on outside click
        document.addEventListener('click', (e) => {
            if (!container.contains(e.target)) {
                results.classList.remove('open');
                iconContainer.classList.remove('open');
            }
        });

        // Initial UI update
        updateUI(container, results, input);

        container.classList.add('dropdown-initialized');

        return true;
    }

    function updateUI(container, results, input) {
        const checkboxes = container.querySelectorAll('.globo-form-input input[type="checkbox"]');
        const selected = Array.from(checkboxes).filter(cb => cb.checked);
        const wrapper = container.querySelector('.eoi-multiselect-wrapper');
        const chips = wrapper.querySelector('.eoi-chips');

        // Don't update input placeholder - keep it as "Select your position"
        // Just keep the placeholder visible

        // Update chips section
        chips.innerHTML = '';
        if (selected.length > 0) {
            chips.classList.remove('hidden');

            selected.forEach(cb => {
                const chip = document.createElement('button');
                chip.type = 'button';
                chip.className = 'eoi-chip';
                chip.setAttribute('aria-label', `Remove ${cb.value}`);
                chip.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
          </svg>
          <span class="eoi-chip-text">${cb.value}</span>
        `;

                chip.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    cb.checked = false;
                    cb.dispatchEvent(new Event('change', { bubbles: true }));
                });

                chips.appendChild(chip);
            });
        } else {
            chips.classList.add('hidden');
        }

        // Update result items checkboxes
        const options = results.querySelectorAll('.eoi-option');
        options.forEach(option => {
            const checkbox = option.querySelector('.eoi-checkbox');
            const label = option.querySelector('.eoi-option-label');
            const originalCheckbox = Array.from(checkboxes).find(cb => cb.value === option.dataset.value);

            if (originalCheckbox && checkbox) {
                checkbox.checked = originalCheckbox.checked;
                if (originalCheckbox.checked) {
                    label.classList.add('eoi-option-label--selected');
                    option.setAttribute('aria-selected', 'true');
                } else {
                    label.classList.remove('eoi-option-label--selected');
                    option.setAttribute('aria-selected', 'false');
                }
            }
        });
    }

    // Initialize after Globo form is fully loaded
    document.addEventListener('globo.formbuilder.form.loaded', () => {
        setTimeout(() => {
            forceInitMultiSelectDropdowns();

            if (!initialized) {
                setTimeout(() => {
                    forceInitMultiSelectDropdowns();

                    if (!initialized) {
                        setTimeout(() => {
                            forceInitMultiSelectDropdowns();

                            if (!initialized) {
                                setTimeout(() => {
                                    forceInitMultiSelectDropdowns();
                                }, 2000);
                            }
                        }, 1000);
                    }
                }, 500);
            }
        }, 200);
    });

    // Fallback initialization on page load
    window.addEventListener('load', () => {
        if (!initialized) {
            setTimeout(() => {
                forceInitMultiSelectDropdowns();

                if (!initialized) {
                    setTimeout(() => {
                        forceInitMultiSelectDropdowns();
                    }, 1500);
                }
            }, 500);
        }
    });
})();
